import { Box, Flex, useDisclosure } from "@chakra-ui/react";
import { lazy, memo } from "react";
import { useLang } from "../../Hooks";
const ChatSidebar = lazy(() => import("../../Components/Support/Sidebar"));
const Conversation = lazy(() =>
  import("../../Components/Support/Conversation")
);

function PageComponent({ Socket }) {
  const { texts } = useLang();
  let Height = {
    base: "auto", 
    md: "calc(100vh - 100px)",
  };
  const { isOpen, onToggle } = useDisclosure({
    defaultIsOpen: true,
  });

  let SidebarWidth = isOpen ? 25 : 7;
  let ConversationWidth = 100 - SidebarWidth;

  // UPDATED: PublicStyle now uses CSS variables
  let PublicStyle = {
    bg: "var(--support-panel-bg)",
    boxShadow: "var(--support-panel-shadow)",
    borderRadius: "lg",
    maxH: Height.md,
    overflow: "hidden",
  };

  return (
    <Flex
      gap={{ base: 4, md: 5 }}
      flexDir={{
        base: "column",
        md: "row",
      }}
      h="full"
    >
      <Box
        w={{
          base: "100%",
          md: `${SidebarWidth}%`,
        }}
        minW={{
          base: "100%",
          md: isOpen ? `280px` : `90px`,
        }}
        transition={"all .3s ease"}
      >
        <ChatSidebar
          Lang={texts}
          PublicStyle={PublicStyle}
          Socket={Socket}
          OnToggle={onToggle}
          IsOpen={isOpen}
        />
      </Box>

      <Box
        w={{
          base: "100%",
          md: `${ConversationWidth}%`,
        }}
        transition={"all .3s ease"}
      >
        <Conversation Lang={texts} Socket={Socket} PublicStyle={PublicStyle} />
      </Box>
    </Flex>
  );
}

const PageComponentFun = memo(PageComponent);
export default PageComponentFun;